import color from "@constants/color";
import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import Text from "@components/CustomText";
import { useNavigation } from "@react-navigation/native";

const OfdListTile = ({ item }) => {
  const navigation = useNavigation();
  const subTitle = ({ subtitle, value }) => {
    return (
      <View style={styles.captionValueContainer}>
        <Text variant="caption_2" style={styles.subtitle}>
          {subtitle}
        </Text>
        <Text variant="caption_2" style={styles.value}>
          {value}
        </Text>
      </View>
    );
  };
  return (
    <TouchableOpacity
      testID="Ofd-list-tile"
      style={styles.container}
      activeOpacity={0.8}
      onPress={() => {
        navigation.navigate("OutForDeliveryDetails", { db: item });
      }}
    >
      <Text variant="title_16" style={styles.title}>
        {item?.db_name}
      </Text>
      <View style={styles.subtitlesContainer}>
        <View>
          {subTitle({
            subtitle: "OFD Marked : ",
            value: item?.marked_ofd_count,
          })}
        </View>
        <View>
          {subTitle({
            subtitle: "Pending OFD :",
            value: item?.pending_ofd_count,
          })}
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default OfdListTile;

const styles = StyleSheet.create({
  container: {
    borderRadius: 10,
    padding: 16,
    paddingVertical: 12,
    margin: 16,
    marginVertical: 8,
    backgroundColor: "white",
  },
  title: {
    color: color.mediumBlack,
  },
  subtitlesContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 4,
  },
  captionValueContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  subtitle: {
    color: color.black06,
    marginRight: 2,
    lineHeight: 18,
  },
  value: {
    color: color.mediumBlack,
    fontWeight: "bold",
  },
});
